module.exports = __webpack_public_path__ + "img/promo-fertigen@1x.1421b03d.png";